<template>
  <div>
    <vx-card>
      <div
        class="py-5 flex flex-col md:flex-row items-center gap-4 mb-4 justify-between"
      >
        <div class="flex flex-col md:flex-row items-center gap-4 w-full md:w-auto">
          <form @submit.prevent="submitSearch()" class="w-full md:w-auto">
            <vs-input
              icon-no-border
              placeholder="Search"
              v-model="searchQuery"
              class="w-full md:w-auto input-square-full"
              icon="icon-search"
              icon-pack="feather"
            />
          </form>
          <div class="flex-grow w-full md:w-auto min-w-250-md">
            <v-select
              label="name"
              placeholder="Site"
              class="w-full"
              v-model="site"
              :options="siteLists"
            ></v-select>
          </div>
        </div>
        <div class="flex gap-4 w-full md:w-auto justify-end">
          <vs-button
            @click="$router.push({ name: 'reports_new' })"
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            >Cancel</vs-button
          >
          <vs-button
            color="#009FB7"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            @click.prevent="addNewCustomReport"
            >Tambah</vs-button
          >
        </div>
      </div>
      <vs-table stripe :data="lists">
        <template slot="thead">
          <vs-th class="text-center">No</vs-th>
          <vs-th
            @click="toggleSort('reportName')"
            class="text-left cursor-pointer"
          >
            <div class="flex items-center">
              <span>Report Name</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('reportName')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('reportName', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('reportName', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th
            @click="toggleSort('parameterEventName')"
            class="text-left cursor-pointer"
          >
            <div class="flex items-center">
              <span>Event</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('parameterEventName')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('parameterEventName', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('parameterEventName', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th class="text-center">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr class="pln-color" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="text-center" :data="indextr">
              {{ (currentPage - 1) * itemsPerPage + indextr + 1 }}
            </vs-td>

            <vs-td class="text-left" :data="tr.name">
              {{ tr.reportName }}
            </vs-td>

            <vs-td class="text-left" :data="tr.event">
              {{ tr.parameterEventName }}
            </vs-td>

            <vs-td class="text-center">
              <div class="flex justify-center gap-mini">
                <vs-tooltip text="Edit">
                  <a class="mr-2" @click.prevent="editCustomReport(tr)">
                    <feather-icon icon="EditIcon" svgClasses="icon" />
                  </a>
                </vs-tooltip>
                <vs-tooltip text="Delete">
                  <a
                    class="mr-2"
                    href="javascript:void(0)"
                    @click.prevent="deleteReport(tr.id)"
                  >
                    <feather-icon icon="TrashIcon" svgClasses="icon" />
                  </a>
                </vs-tooltip>

                <!-- <vs-tooltip text="Detail">
                  <a href="" @click.prevent="openDetailCustomReport(tr)">
                    <feather-icon icon="ChevronRightIcon" svgClasses="icon" />
                  </a>
                </vs-tooltip> -->
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- Pagination -->
      <div class="flex justify-between mt-4">
        <div class="flex items-center">
          <span class="mr-2">Show data</span>
          <vs-select
            class="items-per-page"
            v-model="itemsPerPage"
            @input="updateItemsPerPage"
          >
            <vs-select-item
              v-for="(option, index) in pageOptions"
              :key="index"
              :value="option.value"
              :text="option.text"
            />
          </vs-select>
        </div>

        <CustomPagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          :total-data="totalData"
          @update:currentPage="getLists"
        />
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import api from "@/api";
import dummyData from "./dummy_custom_report.json";
import CustomPagination from "@/components/CustomPagination.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCaretUp, faCaretDown);

import "vue2-datepicker/index.css";

export default {
  data() {
    return {
      disabledDates: {
        from: new Date(),
      },
      daterange: "",
      site: null,
      siteLists: [],
      lists: [],
      searchQuery: "",
      itemsPerPage: 10,
      currentPage: 1,
      totalData: 0,
      totalPages: 0,
      sortField: "",
      sortOrder: "asc",
      pageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
    };
  },
  computed: {
    dummyData() {
      return dummyData;
    },
  },
  watch: {
    site(newVal, oldVal) {
      if (newVal != null && oldVal != newVal) {
        const reportSearch = localStorage.getItem("reportSearch");
        const reportSearchParsed = JSON.parse(reportSearch);
        if (
          reportSearchParsed != undefined &&
          reportSearchParsed != null &&
          reportSearchParsed != ""
        ) {
          reportSearchParsed.site = newVal;
          localStorage.setItem(
            "reportSearch",
            JSON.stringify(reportSearchParsed)
          );
        } else {
          localStorage.setItem(
            "reportSearch",
            JSON.stringify({
              site: newVal,
            })
          );
        }
        this.getLists();
      }
    },
  },
  components: {
    DatePicker,
    vSelect,
    CustomPagination,
    "font-awesome-icon": FontAwesomeIcon,
  },
  beforeMount() {
    const reportSearch = localStorage.getItem("reportSearch");
    const reportSearchParsed = JSON.parse(reportSearch);
    if (
      reportSearchParsed != undefined &&
      reportSearchParsed != null &&
      reportSearchParsed != ""
    ) {
      this.site = reportSearchParsed.site;
    }
  },
  mounted() {
    this.getSiteLists();
  },
  methods: {
    //Update item pages (handling for change limit of page)
    updateItemsPerPage() {
      this.currentPage = 1;
      this.getLists();
    },

    openDetailCustomReport(row) {
      localStorage.setItem("selectedCustomReport", JSON.stringify(row));
      this.$router.push(`/custom_report/${row.id}`);
    },
    // deleteReport(id) {
    //     this.$vs.loading()
    //     api.deleteCustomReport(id)
    //     .then(result => result.data)
    //             .then(data => {
    //                 console.log(data)
    //                 this.$vs.loading.close()
    //             })
    //             .catch((e) => {
    //                 console.log(e)
    //                 this.$vs.loading.close()
    //             });
    // },
    deleteReport(id) {
      this.$vs.loading();
      api
        .deleteCustomReport(id)
        .then((result) => result.data)
        .then((data) => {
          console.log(data);
          this.$vs.notify({
            title: "Success",
            text: "Delete data success",
            color: "success",
            position: "top-right",
          });
          this.$vs.loading.close();
        })
        .finally(() => {
          this.getLists();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            title: "Failed",
            text: "Delete data failed",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    addNewCustomReport() {
      this.$router.push("/custom_report/add");
    },
    getSiteLists() {
      if (this.$store.state.sites.length > 0) {
        this.siteLists = this.$store.state.sites;
      } else {
        this.$vs.loading();
        api
          .sites({
            siteName: this.searchQuery,
          })
          .then((result) => result.data)
          .then((data) => {
            if (data.status) {
              this.siteLists = data.data;
              this.$store.dispatch("updateSiteLists", data.data);
            }
            this.$vs.loading.close();
          })
          .catch((e) => {
            console.log(e);
            this.$vs.loading.close();
          });
      }
    },
    getLists() {
      this.$vs.loading();
      const params = {
        siteId: this.site.id,
        search: this.searchQuery,
        page: this.currentPage,
        limit: this.itemsPerPage,
      };

      if (this.sortField) {
        params.sort = `${this.sortField} ${this.sortOrder}`;
      }

      console.log("📦 [getLists] API Params:", params);

      api
        .getCustomReportLists(params)
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getLists] Response:", data);
          if (data.status) {
            this.lists = data.data;
            this.totalData = data.totalData;
            this.totalPages = data.maxPage;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [getLists] Error:", e);
          this.$vs.loading.close();
        });
    },
    submitSearch() {
      this.currentPage = 1;
      this.getLists();
    },
    toggleSort(field) {
      console.log("🔽 [toggleSort] Clicked field:", field);

      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }

      console.log("🔄 [toggleSort] New sortField:", this.sortField);
      console.log("🔄 [toggleSort] New sortOrder:", this.sortOrder);

      this.getLists();
    },
    getSortClass(field, direction) {
      const isActive = this.sortField === field && this.sortOrder === direction;
      return {
        "sort-icon": true,
        active: isActive,
      };
    },
    editCustomReport(item) {
      localStorage.setItem("selectedCustomReport", JSON.stringify(item));
      this.$router.push(`/custom_report/${item.id}/edit`);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 0 5px;
}
.text-center::v-deep .vs-table-text {
  justify-content: center;
}
.text-left::v-deep .vs-table-text {
  justify-content: flex-start;
}
.cursor-pointer {
  cursor: pointer;
}
.sort-icon-group {
  line-height: 0.7;
}
.sort-icon {
  color: white;
  font-size: 12px;
  transition: opacity 0.2s ease;
}
.sort-icon.active {
  opacity: 1;
  color: #009fb2;
}
.items-per-page {
  width: 80px;
}
::v-deep .items-per-page .vs-select {
  width: 100%;
}
.min-w-250-md {
  width: 100%;
}
@media (min-width: 768px) {
  .min-w-250-md {
    min-width: 250px;
    width: auto;
  }
}
</style>
